export default {"src":"/_next/static/media/achievementFlag.78c9c8e2.svg","height":40,"width":40};